import { App } from './app/App';
import { CardSandbox } from './app/CardSandbox';

const root = document.getElementById('app');
if (!root) throw new Error('missing #app root element');

const params = new URLSearchParams(window.location.search);
const sandbox = params.get('sandbox');
if (sandbox === 'cards') {
  new CardSandbox(root).mount();
} else {
  new App(root).mount();
}
